import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useInterval from '../../helpers/use-interval';
import Auth from '../../logic/redux/auth';
import Button from '../buttons/button';
import Presentation from '../../logic/redux/presentation';
import { FormattedMessage } from 'react-intl';

const TimeoutModalContent = (): JSX.Element => {
  const dispatch = useDispatch();
  const remainingSecs = useSelector(Auth.select.selectRemainingTime);

  const handleContinueClick = (): void => {
    dispatch(Auth.actions.doPostponeTimeout());
    dispatch(Presentation.actions.setShowModal(undefined));
  };

  return (
    <div className="flex flex-col w-1/1">
      <h2 className="mb-4">
        <FormattedMessage id={'timeout.quit'} /> {Math.floor(remainingSecs || 0)}{' '}
        <FormattedMessage id={'timeout.afterSeconds'} />
      </h2>
      <p className="text-12 mb-16">
        <FormattedMessage id={'timeout.timeoutMessage'} />
      </p>
      <Button className="self-end" onClick={handleContinueClick}>
        <FormattedMessage id={'timeout.continueButton'} />
      </Button>
    </div>
  );
};

const Timeout = (): null => {
  const dispatch = useDispatch();
  const authToken = useSelector(Auth.select.selectAuthToken);
  const timeoutTimestamp = useSelector(Auth.select.selectTimeoutTimestamp);

  const refreshRemainingTime = (): void => {
    if (authToken && authToken.expiry && timeoutTimestamp) {
      const remainingSecs =
        (timeoutTimestamp.getTime() + authToken.expiry * 60000 - new Date().getTime()) / 1000;
      if (remainingSecs > 60 && remainingSecs <= 61) {
        dispatch(Presentation.actions.setShowModal(<TimeoutModalContent />));
      }
      if (remainingSecs <= 0) {
        dispatch(Auth.actions.doLogout());
        dispatch(Auth.actions.setRemainingTime(undefined));
        dispatch(Presentation.actions.setShowModal(undefined));
      } else {
        dispatch(Auth.actions.setRemainingTime(remainingSecs));
      }
    }
  };

  useInterval(refreshRemainingTime, 1000);

  return null;
};

export default Timeout;
